module.exports = __webpack_public_path__ + "img/trash-btn.33cfae03.svg";